import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { InvoicePaymentTermValues } from './invoice-payment-term-values.ts'

/**
 * InvoiceTerm
 */
export const [
  InvoiceBillingTerms,
  InvoiceBillingTermsSchema,
  InvoiceBillingTermsMap,
] = EnumBuilder('none', ...InvoicePaymentTermValues)

export type InvoiceBillingTerms = ZodInfer<typeof InvoiceBillingTermsSchema>
